import { Accordion, Box, Flex, Image, useColorModeValue } from '@chakra-ui/react'
import { useLocation } from 'react-router-dom'

import AccordionMenuItem from './AccordionMenuItem'
import menuList from './menuList'
import { State } from 'state/reducers'
import { useSelector } from 'react-redux'
import { useState } from 'react'

import healthLogo from 'assets/images/logo-healthid.png'
import ShrinkMenuItem from './ShrinkMenuItem'

const NavMenu = () => {

    const { pathname } = useLocation();
    const backgroundColor = useColorModeValue('green.800', 'green.800')

    const navBar = useSelector(({ navBar }: State) => navBar)
    const logoWH = navBar ? "50px" : "100px";

    const [isOver, setIsOver] = useState(false);

    const currentOpen = (): number => {
        const currentPath = menuList.find(mn => (mn.subItems && mn.subItems.find(it => pathname.includes(it.url))) || (mn.url && pathname.includes(mn.url)))
        if (!currentPath) return 0
        const current = currentPath.id

        return current
    }

    const navBarWidth = () => {
        if (!navBar) return "240px";
        else if (navBar && isOver) return "240px";
        else if (navBar && !isOver) return "72px";
        else return "0px";
    }

    const onHover = () => {
        setIsOver(true)
    }

    const onHoverOut = () => {
        setIsOver(false)
    }

    const showText = () => {
        if (!navBar || (navBar && isOver)) return true;
        else return false;
    }

    return (
        <Box
            position="fixed"
            left={0}
            top={0}
            zIndex="99"
        >
            <Box
                id="menuBox"
                w={navBarWidth()}
                minH="100vh"
                backgroundColor={backgroundColor}
                transition="width ease .5s"
                // onMouseOver={onHover}
                // onMouseOut={onHoverOut}
            >
                <Flex
                    flexDirection="column"
                    w="full"
                >
                    <Flex w="full" minH="120px" justifyContent="center" alignItems="center">
                        <Image src={healthLogo} w={logoWH} h={logoWH} />
                    </Flex>
                    {
                        !navBar ?
                            <Accordion defaultIndex={[currentOpen() - 1]} allowToggle>
                                {
                                    menuList.map(item => <AccordionMenuItem key={item.id} showText={showText()} {...item} />)
                                }
                            </Accordion>
                        : <>
                            {
                                menuList.map(item => <ShrinkMenuItem key={item.id} showText={showText()} {...item} />)
                            }
                        </>

                    }
                </Flex>
            </Box>
        </Box>
    )
}

export default NavMenu